export const Theme1 = {
  Light: 'light',
  DarkGray: 'dark-gray',
  Green: 'green',
  Blue: 'blue',
  LightBlue: 'light-blue',
  Red: 'red',
} as const;

export const Theme2 = {
  Light: 'light',
  DarkGray: 'dark-gray',
  Green: 'green',
  Blue: 'blue',
  LightBlue: 'light-blue',
  Dark: 'dark',
} as const;

// 각각의 타입
export type Theme1 = (typeof Theme1)[keyof typeof Theme1];
export type Theme2 = (typeof Theme2)[keyof typeof Theme2];

// 두 타입 합치기
export type Theme = Theme1 | Theme2;
